import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { verifySsoToken } from "@/lib/session";

// Verify the SSO token (if present) before mounting the app so the first
// data fetch already uses the verified member identity. If no token is in
// the URL, this is a no-op that resolves immediately.
verifySsoToken().finally(() => {
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 60_000,
                refetchOnWindowFocus: false,
            },
        },
    });
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
        <React.StrictMode>
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </React.StrictMode>,
    );
});
